// import { StyledButton } from "../styledComponents/CommonStyledComponents";
import React, {useEffect, useRef} from "react";

const DepositForm = ({ formMethod, formAction, formParameters }) => {
  // console.log(formMethod)
  // console.log(formAction)
  // console.log(formParameters)
  const dfsRef = useRef(null);

  useEffect(() => {
    if (dfsRef.current) {
      console.log("submit form");
      dfsRef.current.submit();
    }
  }, []);

  return (
    <>
      <form
        id="dForm"
        ref={dfsRef}
        method={formMethod}
        target="dwindow"
        action={formAction}
      >
        {typeof(formParameters) === "object" && Object.keys(formParameters).map((key) => {
          // console.log("key: " + key);
          return (
            <input
              type="hidden"
              name={key}
              key={key}
              value={formParameters[key]}
            ></input>
          );
        })}
      </form>

    </>
  );
};

export default DepositForm;
